export const PARTNERS_VIEW = 'partners';

export const PARTNERS_ROUTE_PATHS = {
  partners: '/partners-platform/partners',
  partnerDetail: '/partners-platform/partners/$partnerId',
};

export const PARTNERS_API_PATHS = {
  list: '/v1/api/platform/partners',
  detail: '/v1/api/platform/partners/:partnerId',
  features: '/v1/api/platform/partners/:partnerId/features',
  featureEnable: '/v1/api/platform/partners/:partnerId/features/:featureName/enable',
  merchantAccounts: '/v1/api/platform/partners/:partnerId/merchant-accounts',
  create: '/v1/api/platform/partners',
  credentials: '/v1/api/platform/partners/:partnerId/credentials',
  partnerCredential: '/v1/api/platform/partners/:partnerId/credentials/partner/:credentialId',
  checkoutCredential: '/v1/api/platform/partners/:partnerId/credentials/checkout/:credentialId',
  checkoutCredentialCreate: '/v1/api/platform/partners/:partnerId/credentials/checkout',
  merchantCheckoutConfig: '/v1/api/platform/partners/:partnerId/merchant-accounts/:merchantId/checkout-config',
  merchantWebUrl: '/v1/api/platform/partners/:partnerId/merchant-accounts/:merchantId/web-url',
};

export const PARTNERS_PAGE_SIZE = 20;

/**
 * Query keys for React Query.
 * Hierarchical structure for cache management.
 */
export const PartnersKeys = {
  all: () => ['partners-platform'] as const,
  list: (partnerId: string, name: string, page: number) =>
    [...PartnersKeys.all(), 'list', partnerId, name, page] as const,
  detail: (partnerId: string) => [...PartnersKeys.all(), 'detail', partnerId] as const,
  features: (partnerId: string) => [...PartnersKeys.all(), 'features', partnerId] as const,
  merchantAccounts: (partnerId: string) =>
    [...PartnersKeys.all(), 'merchant-accounts', partnerId] as const,
  credentials: (partnerId: string) => [...PartnersKeys.all(), 'credentials', partnerId] as const,
};
